var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 181,
    viewBox: "0 0 160 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.889 63.8959C155.44 57.2827 159.535 47.914 159.535 37.7187C159.535 17.0524 143.157 0.519371 122.685 0.519371C109.856 0.519371 98.3916 7.13259 91.8406 17.328C90.2028 18.9813 12.955 114.873 11.5902 117.077C5.03913 123.69 0.944824 133.059 0.944824 143.254C0.944824 163.921 17.3225 180.454 37.7945 180.454C50.6236 180.454 62.0879 173.84 68.639 163.645C70.5497 161.716 147.524 65.8248 148.889 63.8959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignTop);
export default __webpack_public_path__ + "static/media/DesignTop.becfb5c052162cd486973374bb0ae7b8.svg";
export { ForwardRef as ReactComponent };